// Vector logos traced from the JMS Technologies brand guide (see /app/brand/trace.py).
const LOGOS = {
  primary: { src: "/brand/jms-logo-primary.svg", w: 1238, h: 931 },
  reversed: { src: "/brand/jms-logo-reversed.svg", w: 1238, h: 931 },
  "primary-compact": { src: "/brand/jms-logo-primary-compact.svg", w: 1238, h: 806 },
  "reversed-compact": { src: "/brand/jms-logo-reversed-compact.svg", w: 1238, h: 806 },
};

export const Logo = ({ variant = "primary", compact = false, className = "", testId = "brand-logo" }) => {
  const logo = LOGOS[compact ? `${variant}-compact` : variant];
  return (
    <img
      src={logo.src}
      width={logo.w}
      height={logo.h}
      alt="JMS Technologies - Modern Business Solutions"
      className={`w-auto select-none ${className}`}
      data-testid={testId}
    />
  );
};
